import { defineComponent as r, openBlock as l, createBlock as a, unref as i, mergeProps as p, withCtx as c, createElementVNode as n } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconMinusInCircle",
  __name: "IconMinusInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, e) => (l(), a(i(s), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        n("path", { d: "M8 11.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8" }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
